import { useContext } from "react";
import { ContextMenuContext } from "./ContextMenuProvider"

export function useContextMenu() {
  return useContext(ContextMenuContext);
}